import { productSyncTone } from "./formatters.js";
import type {
  MerchantProductsListResponseData,
  ProductListActionsViewModel,
  ProductSyncViewModel,
  ProductTone,
} from "./models.js";

export function productSyncCatalogAction(input: {
  actions: ProductListActionsViewModel;
  submitting: boolean;
}): { enabled: boolean; disabledReason?: string } {
  if (input.submitting) {
    return {
      enabled: false,
      disabledReason: "Catalog sync request is being submitted.",
    };
  }

  if (!input.actions.syncCatalogEnabled) {
    return {
      enabled: false,
      ...(input.actions.syncCatalogDisabledReason === undefined
        ? {}
        : { disabledReason: input.actions.syncCatalogDisabledReason }),
    };
  }

  return { enabled: true };
}

export function productLastSyncedTone(sync: MerchantProductsListResponseData["sync"]): ProductTone {
  return sync.lastSuccessAt === null ? productSyncTone(sync.status) : "good";
}

export function productSyncViewTone(sync: ProductSyncViewModel): ProductTone {
  return sync.status === "RUNNING" && sync.viewJobHref !== undefined ? "warning" : sync.tone;
}
